<template>
  <div>
    <div class="pre-context" v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" v-if="!shownull">
      <div class="context-card add-card flex flex-a-i-center flex-j-c-center">
        <div class="change-box" @click="showedit({_isNew:true}, 0)">
          <img src="@/assets/jia.png" />
          <p>新增</p>
        </div>
      </div>
      <div class="context-card flex flex-j-c-sa" v-for="(e, i) in pageLists" :key="i">
        <div class="card-left flex flex-j-c-sa flex-a-i-center">
          <div class="change-box" @click="showedit(e, i)">
            <img src="@/assets/recruit/icon_modify@3x.png" v-show="!e.isEdit" />
            <img src="@/assets/recruit/cancal.png" v-show="e.isEdit" />
            <p>{{e.isEdit?'取消':'修改'}}</p>
          </div>
					<div class="change-box" @click="showDialog = true;deleteId=e.id">
					  <img src="@/assets/recruit/delete@3x.png" />
					  <p>删除</p>
					  
					</div>
					 <!-- 自定义对话框 -->
					    <div v-if="showDialog" class="dialog-overlay">
					      <div class="dialog">
					        <p style="color: red; margin-left: 5px;">确定要删除吗？</p>
							<div style="margin-top: 10px;"> <button @click="confirmDelete(e,i)" style="margin-right: 20px;" class="button">确定</button> 
					        <button @click="showDialog = false"  class="button">取消</button></div>
					      </div>
					    </div>
          <div class="change-box" @click="showqrcode(e, i)">
            <img src="@/assets/recruit/icon_qrcode@3x.png" v-show="!e.isEdit" />
            <img src="@/assets/recruit/icon_save@3x.png" v-show="e.isEdit" />
            <p>{{e.isEdit?'保存':'报名二维码'}}</p>
          </div>
        </div>
        <div class="card-right">
          <div class="flex text-line flex-a-i-center">
            <p class="text-left">姓名：</p>
            <p v-show="!e.isEdit">{{e.true_name}}</p>
            <input type="text" class="text-style" v-show="e.isEdit" v-model.trim="setData.true_name" placeholder="请输入姓名" />
          </div>
          <!-- <div class="flex text-line flex-a-i-center" @click="showPopup('college', e)">
                  <p class="text-left">志愿：</p>
                  <p class="text-right ellipsis" :class="e.isEdit ? 'text-style':''">{{e.isEdit ? setData.first_name:e.first_name}}</p>
                </div> -->
          <div class="flex text-line flex-a-i-center" @click="showPopup('college', e)">
            <p class="text-left">院校：</p>
            <p class="text-right ellipsis" :class="e.isEdit ? 'text-style':''">{{e.isEdit ? setData.first_name:e.first_name}}</p>
          </div>
          <div class="flex text-line flex-a-i-center" @click="showPopup('arrangement', e)">
            <p class="text-left">层次：</p>
            <p class="text-right ellipsis" :class="e.isEdit ? 'text-style':''">{{e.isEdit ? setData.second_name:e.second_name}}</p>
          </div>

          <div class="flex text-line flex-a-i-center" @click="showPopup('major', e)">
            <p class="text-left">专业：</p>
            <p class="text-right ellipsis" :class="e.isEdit ? 'text-style':''">{{e.isEdit ? setData.goods_name:e.goods_name}}</p>
          </div>
          <div class="flex text-line flex-a-i-center" @click="showPopup('campus', e)">
            <p class="text-left">服务校区：</p>
            <p class="text-right ellipsis" :class="e.isEdit ? 'text-style':''">{{e.isEdit ? setData.campus:e.campus}}</p>
          </div>
          <div class="flex text-line flex-a-i-center" @click="showInvi(e, true)">
            <p class="text-left">推荐人：</p>
            <p class="text-right ellipsis" :class="e.isEdit ? 'text-style':''">{{e.isEdit ? setData.inviter_name:e.inviter_name}}</p>
          </div>
          <div class="flex text-line flex-a-i-center">
            <p class="text-left">手机号码：</p>
            <p v-show="!e.isEdit">{{e.mobile}}</p>
            <input type="number" class="text-style" v-show="e.isEdit" v-model.trim="setData.mobile" placeholder="请输入手机号码" />
          </div>
          <div class="flex text-line flex-a-i-center">
            <p class="text-left">证件号码：</p>
            <p v-show="!e.isEdit">{{e.idcard}}</p>
            <input type="text" v-show="e.isEdit" class="text-style" v-model.trim="setData.idcard" placeholder="请输入身份证号码" />
          </div>

          <!-- 联系地址 -->
          <div style="text-align :center">
            <v-region-selects v-show="e.isEdit" @change="regionChange" :town="true" />
          </div>
          <div class="flex text-line flex-a-i-center">

            <div class="flex flex-j-c-e method-right">
              <p class="text-left">现住址：
              </p>

              <p class="text-right ellipsis" :class="e.isEdit ? 'text-style':''">

                {{e.isEdit ?  county:e.county}}</p>

            </div>
          </div>

          <!-- <div class="flex text-line flex-a-i-center">
            <p class="text-left">详细地址：</p>
            <p v-show="!e.isEdit">{{e.detailed_address}}</p>
            <input type="text" class="text-style" v-show="e.isEdit" v-model.trim="setData.detailed_address" placeholder="详细地址" />
          </div> -->

          <!-- 单位 -->
          <div class="card-right">
            <div class="flex text-line flex-a-i-center">
              <p class="text-left">单位：</p>
              <p v-show="!e.isEdit">{{e.unit}}</p>
              <input type="text" class="text-style" v-show="e.isEdit" v-model.trim="setData.unit" placeholder="请输入单位" />
            </div>
          </div>

          <div class="card-right">
            <div class="flex text-line flex-a-i-center">
              <p class="text-left">紧急联系人：</p>
              <p v-show="!e.isEdit">{{e.crash_linkman}}</p>
              <input type="text" class="text-style" v-show="e.isEdit" v-model.trim="setData.crash_linkman" placeholder="请输入紧急联系人姓名" />
            </div>
          </div>
          <div class="card-right">
            <div class="flex text-line flex-a-i-center">
              <p class="text-left">手机号码：</p>
              <p v-show="!e.isEdit">{{e.crash_mobile}}</p>
              <input type="text" class="text-style" v-show="e.isEdit" v-model.trim="setData.crash_mobile" placeholder="请输入紧急联系人手机号码" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <mt-popup v-model="popupVisible" popup-transition="popup-fade" position="bottom" class="mint-popup">
      <mt-picker :slots="slots" :valueKey="Indexes" @change="onValuesChange" :itemHeight="50" showToolbar ref="picker">
        <mt-header :title.sync="popupName">
          <mt-button slot="left" @click="popupVisible = false">取消</mt-button>
          <mt-button slot="right" @click="handleConfirm">确定</mt-button>
        </mt-header>
      </mt-picker>
    </mt-popup>
    <DataNull v-if="shownull" />
    <Nomore v-if="showNoMore" />
    <div class="mask" v-show="isShowInviter" style="background: rgba(0, 0, 0, 0.7);">
      <img src="@/assets/home/Receive_icon_close@3x.png" class="mask-close" @click="showInvi({isEdit: true}, false)">
      <div class="seach-box">
        <van-search v-model.trim="inviterkw" placeholder="请输入姓名" show-action shape="round" @search="onSearch" style="height:0.5rem;">
          <!-- <div slot="action" @click="showInvi({isEdit: true}, false)" style="color:#FABF01">取消</div> -->
          <div slot="action" @click="onSearch" style="color:#FABF01">搜索</div>
        </van-search>
        <div class="per-line flex flex-j-c-sb" v-for="(e, i) in inviterArr" :key="`${i}one`">
          <div class="flex flex-a-i-center">
            <img :src="e.avatar_url || require('@/assets/teamAvatar.png')" class="item-avatar" />
            <div class="item-box flex flex-a-i-center flex-j-c-sb">
              <p class="item-name">{{e.true_name || e.nickname}}</p>
            </div>
          </div>
          <div class="flex flex-a-i-center" @click="chooseInviter(e)">
            <p class="item-text">选择</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  GetCollege,
  modityLink,
  cityLink,
  campusLink,
  GetTPreview,
  EditMessage,
  searchInviter,
  DeleteMessage,
} from '@/api'
import { Indicator, MessageBox, Toast } from 'mint-ui'
import DataNull from '@/components/DataNull'
import Nomore from '@/components/Nomore'
import ConfirmDialog from '@/components/ConfirmDialog';
export default {
  name: 'PreAdd',
  components: {
	ConfirmDialog,
    DataNull,
    Nomore,
  },
  data() {
    return {
      teacher_id: '',
      pageLists: [], // 页面列表
      collegeData: [], // 院校数据
      servicCampusArr: [], // 服务校区数据
      inviterArr: [], // 推荐人数据
      kw: '', // url keyword
      inviterkw: '', // 搜索推荐人
      setData: { _cantEdit: false }, // 预更换数据
      isShowInviter: false,
      changeCityIndex: [0, 0, 0], // 城市更改id
      loading: true,
      page: 1,
      shownull: false,
      showNoMore: false,
      cityShow: '',
      popupVisible: false, // picker 显示/隐藏
      popupType: '', // 联动类型
      popupName: '', // 联动名称
      Indexes: 'name', // 联动索引
      slots: [{ values: [] }],
      college: {}, // 校区
      arrangement: {}, // 层次
      major: {}, // 专业
      campus: {}, // 院校
      sessionData: {},
      // detailed_address: '',
      county: '',
	  showDialog:false,//控制对话框显示/隐藏
	  deleteId:0,
    }
  },
  created() {
    this.kw = this.$route.query.kw || ''
    this.getpageData()
    this.getPreView()
    this.getCampus()
    this.getCity()
  },
  watch: {
    $route(a, b) {
      this.loading = true
      this.page = 1
      this.shownull = false
      this.showNoMore = false
      this.kw = this.$route.query.kw || ''
      this.pageLists = []
      this.getpageData()
    },
  },
  methods: {
    //选择城市
    regionChange(data) {
      console.log(data)

      // console.log(
      //   data.province.value + '-' + data.city.value + '-' + data.area.value + '-' + data.town.value
      // )
      if (data.province != null) {
        this.county = data.province.value
      }

      if (data.city != null) {
        this.county = this.county + '-' + data.city.value
      }

      if (data.area != null) {
        this.county = this.county + '-' + data.area.value
      }

      if (data.town != null) {
        this.county = this.county + '-' + data.town.value
      }
    },
    // 城市联动接口
    getCity() {
      cityLink().then((res) => {
        this.cityData = res.data

        let defaultCity = [{}, {}],
          cindex = 0
        if (res.data.length !== 0) {
          res.data.map((item, index) => {
            if (item.id === 19411) {
              this.cityData = [item]
              defaultCity[0] = item
              defaultCity[1] = item.list[0]
              console.log(item.list[0])
              cindex = index
            }
          })
          this.city = defaultCity
          this.cindex = cindex
          // this.cityShow = localStorage.getItem('cityShow')
          // this.cityShow = `${this.city[0].name}-${this.city[1].name}`
        }
      })
    },
    // 变更选项
    onValuesChange(picker, values) {
     
      if (!this.popupType) return false
      if (this.popupType === 'city') {
        let province = values[0]
      
        let city = values[1]
       
        let district = values[2]
      
        if (province.id !== this.changeCityIndex[0].id) {
          this.changeCityIndex[0] = province.id
          picker.setSlotValues(1, province.list)
          // picker.setSlotValues(2, province.list[0].list)
        }
        if (city.id !== this.changeCityIndex[1].id) {
          this.changeCityIndex[1] = city.id
          picker.setSlotValues(2, city.list)
        }
        if (district.id !== this.changeCityIndex[2].id) {
          this.changeCityIndex[2] = district.id
          picker.setSlotValues(2, province.list[0].list)
          picker.setSlotValues(2, city.list)
          console.log(province.list[0].list)
        }
      }
    },
    // 加载更多
    loadMore() {
      if (this.loading) return false
      this.loading = true
      this.page += 1
      this.getpageData()
    },
	//删除预报名学生
	confirmDelete(e,i) {
      this.showDialog=false		
	 let params={
		  deleteId:this.deleteId,
	  }
	  DeleteMessage(params).then((res) => {
		  //console.log(res)
	    if (res==1) {
	      Toast({ message: '删除成功', className: 'iconfont icon-dui' })
	      setTimeout(() => {
	        window.location.reload()
	      }, 1500)
	      // data.isEdit = false;
	      // this.pageLists.splice(data._index, 1, data);
	      // this.setData = {_cantEdit: false};
	    } else {
	      Toast({ message: "删除操作出现未知错误", className: 'iconfont icon-close' })
	    }
	  })
	},
    // 预报名院校获取接口
     getPreView() {
      GetCollege().then((res) => {
        let colObj = {}
        res.data.map((item, index) => {
          if (item.id == 68) {
            colObj.item = item
            colObj.index = index
          }
        })
        res.data.splice(colObj.index, 1)
        res.data.unshift(colObj.item)
        this.collegeData = res.data
      })
    },
    // 列表数据获取
     getpageData() {
      GetTPreview({ page: this.page, limit: 10, keyword: this.kw }).then((res) => {
        console.log(res.data)
        // console.log(res.data[0].teacher_id)
        this.teacher_id = res.teacher_id
        if (res.code === 0) {
          this.pageLists = this.pageLists.concat(res.data)
          // if (res.data.length === 0) { this.shownull = true };
          if (res.data.length === 10) {
            this.loading = false
          }
          if (res.data.length !== 10 && res.data.length !== 0) {
            this.showNoMore = true
          }
          if (Number(res.totalCount) === this.pageLists.length) {
            this.loading = true
            this.showNoMore = true
          }
        } else {
          // this.shownull = true;
        }
      })
    },
    //  打开编辑（e.isEdit = false）or取消（e.isEdit = true）
    showedit(e, i) {
      this.county = e.county
      console.log(e.id)
      if (e.isEdit) {
        e.isEdit = false
        if (e._isNew) {
          this.pageLists.splice(i, 1)
        } else {
			
          this.pageLists.splice(i, 1, e)
        }
        this.setData = { _cantEdit: false }
      } else {
        if (this.setData._cantEdit) {
          Toast({
            message: '正在编辑其他报名单，不可以对其他报名单进行操作。',
            className: 'iconfont icon-close',
          })
          return false
        }
        if (e._isNew) {
          this.sessionData = JSON.parse(sessionStorage.getItem('_sessionData'))
          console.log(this.sessionData)
          let uid = JSON.parse(localStorage.getItem('cww_data')).id // let uid = 36830

          e = {
            campus: '请选择',
            campus_id: -1,
            enrolment_id: '14',
            first_cat_id: -1,
            first_name: '请选择',
            goods_id: -1,
            goods_name: '请选择',
            id: 0,
            idcard: '',
            inviter_id: uid || -1,
            inviter_name:
              JSON.parse(this.sessionData.RecruitIndex).true_name ||
              JSON.parse(this.sessionData.RecruitIndex).nickname ||
              '请选择',
            mobile: '',
            second_cat_id: -1,
            second_name: '请选择',
            true_name: '',
            crash_linkman: '',
            crash_mobile: '',
            unit: '',

            province_id: '',
            city_id: '',
            _isNew: true,
            isEdit: true,
            _cantEdit: true,
            county: this.county,
          }
          this.pageLists.unshift(e)
          this.setData = this._tools.deepClone(e)
        } else {
          e.isEdit = true
          e._cantEdit = true
          this.pageLists.splice(i, 1, e)
          this.setData = this._tools.deepClone(e)
        }
      }
    },
    // 跳转支付二维码（e.isEdit = false）or保存（e.isEdit = true）
    showqrcode(e, i) {
      if (e.isEdit) {
        // 更新操作
        let judgeInput = this.setData.true_name && this.setData.mobile && this.setData.idcard,
          judgeVolunteer =
            this.setData.first_cat_id !== -1 &&
            this.setData.second_cat_id !== -1 &&
            this.setData.goods_id !== -1,
          judgeCampus = this.setData.campus_id !== -1 && this.setData.inviter_id !== -1
        if (!this._tools.checkIdentityLegal(this.setData.idcard)) {
          Toast({ message: '请输入正确的身份证号码', className: 'iconfont icon-close' })
          return false
        }
        if (!this._tools.checkPhone(String(this.setData.mobile))) {
          Toast({ message: '请输入正确的手机号码', className: 'iconfont icon-close' })
          return false
        }
        if (judgeInput && judgeVolunteer && judgeCampus) {
          this.setData._index = i
          this.isEdit = false
          this.saveMessage(this.setData)
        } else {
          Toast({ message: '请完善信息', className: 'iconfont icon-close' })
        }
      } else {
        // 跳转支付二维码
        this.$router.push({ path: `/PreviewPay?pid=${e.id}&type=2` })
      }
    },
    // 选择选项
    showPopup(str, e) {
      if (!e.isEdit) {
        return false
      }
      let judge = true
      switch (str) {
        case 'college': // 院校
          if (this.collegeData.length === 0) {
            Toast({ message: '暂无数据', className: 'iconfont icon-close' })
            judge = false
          }
          if (this.collegeData !== this.slots[0].values) {
            this.slots = [
              { flex: 1, values: this.collegeData, className: 'slot1', textAlign: 'center' },
            ]
            this.Indexes = 'name'
            this.popupName = '选择院校'
          }
          break
        case 'arrangement': // 层次
          if (!this.college.id) {
            Toast({ message: '请选择院校', className: 'iconfont icon-close' })
            judge = false
          } else if (this.college.son.length === 0) {
            Toast({ message: '暂无层次信息', className: 'iconfont icon-close' })
            judge = false
          }
          if (this.college.son !== this.slots[0].values) {
            this.slots = [
              { flex: 1, values: this.college.son, className: 'slot1', textAlign: 'center' },
            ]
            this.Indexes = 'name'
            this.popupName = '选择层次'
          }
          break
        case 'major': // 专业
          if (!this.arrangement.id) {
            Toast({ message: '请选择层次', className: 'iconfont icon-close' })
            judge = false
          } else {
            this.getModity(0)
            judge = false
          }
          break
        case 'campus': // 院校
          if (this.slots[0].values !== this.servicCampusArr) {
            this.slots = [
              { flex: 1, values: this.servicCampusArr, className: 'slot1', textAlign: 'center' },
            ]
            this.Indexes = 'name'
            this.popupName = '选择校区'
          }
          if (this.servicCampusArr.length === 0) {
            Toast({ message: '暂无可选择校区', className: 'iconfont icon-close' })
            judge = false
          }
          break
        case 'city': // 城市
          let province = this.cityData
          let city = this.cityData[0].list
          let district = this.cityData[0].list[0].list
          console.log(province)
          console.log(city)
          console.log(district)
          // let district = this.cityData[0].list[0].list;
          this.slots = [
            {
              flex: 1,
              values: province,
              className: 'slot1',
              textAlign: 'center',
              defaultIndex: this.cindex,
            },
            {
              divider: true,
              content: '-',
              className: 'slot2',
            },
            {
              flex: 1,
              values: city,
              className: 'slot3',
              textAlign: 'center',
            },

            {
              divider: true,
              content: '-',
              className: 'slot2',
            },
            {
              flex: 1,
              values: district,
              className: 'slot4',
              textAlign: 'center',
            },
          ]
          this.servicCampus = {}
          this.popupName = '城市'
          break
        default:
          Toast({ message: '请稍后重试', className: 'iconfont icon-close' })
          judge = false
          break
      }
      if (judge) {
        this.popupVisible = true
        this.popupType = str
      }
    },
    // 确定选项
    handleConfirm() {
      switch (this.popupType) {
        case 'college':
          this.college = this.$refs.picker.getValues()[0]
          this.setData.first_name = this.college.name
          this.setData.first_cat_id = this.college.id
          /** -----------------------重置----------------------------- */
          this.arrangement = {}
          this.setData.second_name = '请选择'
          this.setData.second_cat_id = -1

          this.major = {}
          this.setData.goods_name = '请选择'
          this.setData.goods_id = -1

          /** -----------------------重置----------------------------- */
          break
        case 'arrangement':
          this.arrangement = this.$refs.picker.getValues()[0]
          this.setData.second_name = this.arrangement.name
          this.setData.second_cat_id = this.arrangement.id
          /** -----------------------重置----------------------------- */
          this.major = {}
          this.setData.goods_name = '请选择'
          this.setData.goods_id = -1
          /** -----------------------重置----------------------------- */
          break
        case 'major':
          this.major = this.$refs.picker.getValues()[0]
          this.setData.goods_name = this.major.name
          this.setData.goods_id = this.major.id
          break
        case 'campus':
          this.campus = this.$refs.picker.getValues()[0]
          this.setData.campus = this.campus.name
          this.setData.campus_id = this.campus.id
          break
        default:
          Toast({ message: '请稍后重试', className: 'iconfont icon-close' })
          break
        case 'city':
          console.log(this.$refs.picker.getValues())
          this.city = [
            this.$refs.picker.getValues()[0],
            this.$refs.picker.getValues()[1],
            this.$refs.picker.getValues()[2],
          ]
          this.cityShow = `${this.city[0].name}-${this.city[1].name}-${this.city[2].name}`
          console.log(this.cityShow)
          console.log(this.city[0].id + '~~~~~~' + this.city[1].id + '~~~~~~' + this.city[2].id)
          this.setData.county = this.cityShow
          // localStorage.setItem('cityShow', this.cityShow)

          break
      }
      this.popupVisible = false
    },
    // 专业联动数据接口
    getModity(e) {
      let params = {
        first_cat_id: this.college.id, // 院校id
        second_cat_id: this.arrangement.id, // 层次id
      }
      modityLink(params).then((res) => {
        if (res.code === 0) {
          if (e === 1) {
            res.data.map((item) => {
              if ((item.name = this.pageData.major)) {
                this.major = item
              }
            })
            // this.major = res.data[0]
          } else {
            if (this.slots[0].values !== res.data) {
              this.slots = [{ flex: 1, values: res.data, className: 'slot1', textAlign: 'center' }]
              this.popupType = 'major'
              this.popupName = '选择专业'
              this.Indexes = 'name'
            }
            this.popupVisible = true
          }
        } else {
          Toast({ message: res.msg, className: 'iconfont icon-close' })
        }
      })
    },
    // 校区联动接口
    getCampus() {
      campusLink({ city_id: 0 }).then((res) => {
        if (res.code === 0) {
          this.servicCampusArr = res.data
        } else {
          this.campus = { name: '暂无' }
        }
      })
    },
    // 保存修改
    saveMessage(data) {
      let params = {
        id: Number(data.id),
        true_name: data.true_name,
        crash_linkman: data.crash_linkman,
        county: this.county,
        crash_mobile: data.crash_mobile,
        teacher_id: this.teacher_id,

        unit: data.unit,
        mobile: data.mobile,
        idcard: data.idcard,
        enrolment_id: data.enrolment_id,
        goods_id: data.goods_id,
        first_cat_id: data.first_cat_id,
        second_cat_id: data.second_cat_id,
        campus_id: data.campus_id,
        inviter_id: data.inviter_id,
        // detailed_address: data.detailed_address,
      }
      EditMessage(params).then((res) => {
        if (res.code === 0) {
          Toast({ message: '更新成功', className: 'iconfont icon-dui' })
          setTimeout(() => {
            window.location.reload()
          }, 1500)
          // data.isEdit = false;
          // this.pageLists.splice(data._index, 1, data);
          // this.setData = {_cantEdit: false};
        } else {
          Toast({ message: res.msg, className: 'iconfont icon-close' })
        }
      })
    },
    // 搜索
    onSearch() {
      searchInviter({ keyword: this.inviterkw }).then((res) => {
        if (res.code === 0) {
          this.inviterArr = res.data
        } else {
          Toast({ message: res.msg, className: 'iconfont icon-close' })
        }
      })
    },
    // 选择推荐人
    chooseInviter(e) {
      this.setData.inviter_name = e.true_name
      this.setData.inviter_id = e.id
      this.isShowInviter = false
    },
    // 打开&关闭推荐人搜索
    showInvi(e, i) {
      console.log(1)
      if (e.isEdit) {
        this.inviterArr = []
        this.isShowInviter = i
      }
    },
  },
}
</script>

<style lang="less" scoped>
.pre-context {
  padding: 1.64rem 0 0;
  .context-card {
    width: 3.43rem;
    padding: 0.1rem;
    margin: 0 auto 0.1rem;
    background: white;
    border-radius: 5px;
    .change-box {
      img {
        width: 0.3rem;
        height: 0.3rem;
      }
      p {
        margin-top: 0.04rem;
        font-size: 0.125rem;
        color: #999;
      }
    }
    .card-left {
      flex-direction: column;
    }
    .card-right {
      .text-line {
        line-height: 0.3rem;
        font-size: 0.125rem;
        .text-left {
          width: 0.8rem;
          text-align: right;
          color: #999;
        }
        .text-right {
          max-width: 1.6rem;
        }
      }
    }
  }
  .add-card {
    height: 1rem;
  }
  .text-style {
    border: none;
    background: #f6f6fa;
    border-radius: 3px;
    height: 0.25rem;
    padding: 0 0.05rem;
    min-width: 0.93rem;
  }
}
.mint-popup {
  width: 100%;
  border-radius: 8px 8px 0 0;
}
.mint-popup /deep/ .picker {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background: white;
  border-radius: 8px 8px 0 0;
  .mint-header {
    background: white;
    height: 0.5rem;
    padding: 0 0.16rem;
    font-size: 0.15rem;
    .is-left {
      color: #999999;
    }
    .is-right {
      color: #fabf01;
    }
  }
  .mint-header-title {
    font-size: 0.17rem;
    color: black;
  }
}
/deep/ .picker-selected {
  color: #fabf01;
}
/deep/ .mint-datetime-confirm {
  color: #fabf01;
}
/deep/ .mint-datetime-cancel {
  color: #999;
}
.per-line {
  height: auto;
  line-height: 0.4rem;
  padding: 0.1rem 0.16rem;
  background: white;
}
.item-avatar {
  width: 0.56rem;
  height: 0.56rem;
  margin-right: 0.12rem;
  border-radius: 50%;
}
.item-name {
  font-size: 0.16rem;
  width: 100%;
  margin-bottom: 0.1rem;
}
.item-time {
  color: #999999;
  font-size: 0.12rem;
  width: 100%;
  text-align: right;
  margin-bottom: 0.1rem;
}
.item-text {
  font-size: 0.14rem;
  color: white;
  width: 0.7rem;
  height: 0.24rem;
  line-height: 0.24rem;
  border-radius: 0.12rem;
  background: linear-gradient(90deg, #fabf01, #fa9901);
  text-align: center;
}
.item-texts {
  background: white;
  border: 1px solid #fabf01;
  color: #fabf01;
  margin-right: 0.1rem;
}
.seach-box {
  width: 90%;
  padding: 0.16rem;
  position: relative;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: white;
  border-radius: 0.1rem;
  max-height: 55vh;
  overflow-y: scroll;
  & > div {
    border: none;
  }
}
.mask-close {
  width: 0.3rem;
  height: 0.3rem;
  position: absolute;
  top: 0.5rem;
  right: 5%;
  // left: 50%;
  // transform: translateX(-50%);
}
/deep/ div.rg-select div.rg-select__el div.rg-select__content {
  padding: 0;
  color:#FABF01;
}
/deep/ div.rg-select  {
  padding:3px;
}
/deep/ div.rg-select__el  {
  border: 1px solid #fabf01;
  border-radius: 10px;
}
.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.dialog {
  background: white;
  padding: 80px;
  border-radius: 5px;
  text-align: center;
}
.dialog .button{padding: 0.10rem;border-radius: 5px;font-size: 0.13rem;color:black}
</style>
